import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

const NextLink = ({ href, activeClassName, children, scroll, as }) => {
  const router = useRouter()

  const child = React.Children.only(children)

  let className = child.props.className || ''
  if (router.pathname === href && activeClassName) {
    className = `${className} ${activeClassName}`.trim()
  }

  return (
    <Link href={href} passHref scroll={scroll} as={as}>
      {React.cloneElement(child, { className })}
    </Link>
  )
}

NextLink.defaultProps = {
  href: '/',
  activeClassName: 'next-link-active',
  scroll: true,
  as: undefined,
}

NextLink.propTypes = {
  href: PropTypes.string,
  scroll: PropTypes.bool,
  activeClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  as: PropTypes.string,
}

export default NextLink
